/* BAVELIOM — vanilla JS. No framework, no dependencies. */
(function () {
  'use strict';
  var CFG = window.BAVELIOM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ── utilities ────────────────────────────────── */
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 2400);
  }

  function store(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (e) { return fallback; }
  }
  function save(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }

  /* Theme preference gets a first-party cookie alongside localStorage. Belt and
     suspenders: some browsers cap or partition localStorage (private windows,
     the theme-editor preview iframe, strict tracking prevention) but still
     allow a plain first-party cookie, so this keeps the choice sticky either way. */
  function saveTheme(val) {
    save('bavl_theme', val);
    try { document.cookie = 'bavl_theme=' + encodeURIComponent(JSON.stringify(val)) + '; max-age=31536000; path=/; SameSite=Lax'; } catch (e) {}
  }

  /* ── scroll reveal ────────────────────────────── */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 })
    : null;

  function observeReveals(root) {
    if (!io) { $$('.reveal', root).forEach(function (el) { el.classList.add('is-in'); }); return; }
    $$('.reveal:not(.is-in)', root).forEach(function (el) { io.observe(el); });
  }

  /* ── theme toggle ─────────────────────────────── */
  /* Bug fix: the toggle label used to be set from the shop's default color
     mode setting and only ever refreshed inside the click handler. If a
     visitor's saved preference differed from that shop default (the normal
     case once someone has switched once), the label showed the wrong state
     on every fresh page — e.g. still reading "Dark" while the page had
     already restored dark mode — so pressing it looked like it "undid" the
     choice instead of confirming it. syncLabel() now runs immediately on
     every init, not just after a click, so the label always matches the
     theme that's actually applied. */
  function syncThemeLabel() {
    var current = document.documentElement.dataset.theme;
    $$('[data-theme-label]').forEach(function (l) { l.textContent = current === 'dark' ? l.dataset.light : l.dataset.dark; });
  }
  function initTheme() {
    syncThemeLabel();
    $$('[data-theme-toggle]').forEach(function (btn) {
      if (btn.dataset.themeBound === 'true') return;
      btn.dataset.themeBound = 'true';
      btn.addEventListener('click', function () {
        var next = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
        document.documentElement.dataset.theme = next;
        saveTheme(next);
        syncThemeLabel();
      });
    });
  }

  /* ── drawers ──────────────────────────────────── */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('[autofocus], input, button');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.mobile-nav.is-open')) document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer, .mobile-nav')); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        $$('.drawer.is-open, .mobile-nav.is-open').forEach(closeDrawer);
        $$('.mega.is-open').forEach(function (m) { m.classList.remove('is-open'); });
      }
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openDrawer('SearchDrawer'); }
    });
    // focus trap
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var open = $('.drawer.is-open .drawer__panel, .mobile-nav.is-open .mobile-nav__panel');
      if (!open) return;
      var f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', open)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ── mobile nav ───────────────────────────────── */
  function initMobileNav() {
    var nav = $('#MobileNav');
    if (!nav) return;
    $$('[data-mobile-nav-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        openDrawer('MobileNav');
      });
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) closeDrawer(nav);
      if (e.target.matches('.mobile-nav__overlay, [data-drawer-close]')) closeDrawer(nav);
    });
  }

  /* ── announcement bar dismiss ─────────────────── */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var key = 'bavl_announcement_' + (bar.dataset.announcement || '1');
    if (store(key, false) === true && !window.Shopify?.designMode) { bar.remove(); return; }
    var slides = $$('[data-announcement-slide]', bar);
    var index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var timer = null;
    function show(next) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (slide.tagName === 'A') slide.tabIndex = active ? 0 : -1;
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (bar.dataset.autoplay !== 'true' || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(index + 1); }, (parseInt(bar.dataset.speed, 10) || 3) * 1000);
    }
    var prev = $('[data-announcement-prev]', bar);
    var next = $('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    show(index);
    start();
    var close = $('[data-announcement-close]', bar);
    if (close) close.addEventListener('click', function () { stop(); save(key, true); bar.style.display = 'none'; });
  }

  /* ── product card image slideshows ───────────── */
  function initProductCardSlides(root) {
    $$('[data-card-slideshow]', root || document).forEach(function (slideshow) {
      if (slideshow.dataset.slideshowReady === 'true') return;
      slideshow.dataset.slideshowReady = 'true';
      var slides = $$('[data-card-slide]', slideshow);
      if (slides.length < 2) return;
      var card = slideshow.closest('.card');
      var index = 0;
      var timer = null;
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }
      function stop(reset) {
        if (timer) { clearInterval(timer); timer = null; }
        if (reset) show(0);
      }
      card.addEventListener('mouseenter', function () {
        stop(false);
        timer = setInterval(function () { show(index + 1); }, 2700);
      });
      card.addEventListener('mouseleave', function () { stop(true); });
    });
  }

  /* ── homepage product hero carousel ───────────── */
  function initProductHeroes(root) {
    $$('[data-product-hero]', root || document).forEach(function (carousel) {
      if (carousel.dataset.heroReady === 'true') return;
      carousel.dataset.heroReady = 'true';
      var slides = $$('[data-product-hero-slide]', carousel);
      if (!slides.length) return;
      var index = 0;
      var counter = $('[data-product-hero-current]', carousel);
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        if (counter) counter.textContent = index + 1;
      }
      var prev = $('[data-product-hero-prev]', carousel);
      var next = $('[data-product-hero-next]', carousel);
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      $$('[data-product-hero-media]', carousel).forEach(function (media) {
        var mediaSlides = $$('[data-product-hero-media-slide]', media);
        if (mediaSlides.length < 2) return;
        var mediaIndex = 0;
        var mediaTimer = null;
        function showMedia(nextMedia) {
          mediaIndex = (nextMedia + mediaSlides.length) % mediaSlides.length;
          mediaSlides.forEach(function (slide, i) {
            var active = i === mediaIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        }
        media.addEventListener('mouseenter', function () {
          if (mediaTimer) clearInterval(mediaTimer);
          mediaTimer = setInterval(function () { showMedia(mediaIndex + 1); }, 2700);
        });
        media.addEventListener('mouseleave', function () {
          if (mediaTimer) clearInterval(mediaTimer);
          mediaTimer = null;
          showMedia(0);
        });
      });
      show(0);
    });
  }

  /* ── cart ─────────────────────────────────────── */
  function renderCartSections(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['CartDrawerBody', 'CartDrawerFooter', 'CartPageContents'].forEach(function (id) {
      var next = doc.getElementById(id), cur = document.getElementById(id);
      if (next && cur) cur.innerHTML = next.innerHTML;
    });
    var count = doc.querySelector('[data-cart-count]');
    if (count) $$('[data-cart-count]').forEach(function (el) { el.textContent = count.textContent; });
    observeReveals(document);
  }

  function refreshCart(open) {
    return fetch(CFG.routes.cart_url + '?section_id=cart-drawer-refresh', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        renderCartSections(html);
        if (open) openDrawer('CartDrawer');
      });
  }

  function addToCart(form, btn) {
    var body = new FormData(form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return fetch(CFG.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { toast(data.description || data.message); return; }
        toast((data.product_title || '') + ' — ' + (CFG.strings.added || 'added'));
        return refreshCart(true);
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  function changeLine(key, quantity, node) {
    if (node) node.classList.add('is-loading');
    return fetch(CFG.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(false); });
  }

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      addToCart(form, form.querySelector('[type=submit]'));
    });
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-line-change]');
      if (q) {
        e.preventDefault();
        var line = q.closest('[data-line-key]');
        changeLine(line.dataset.lineKey, parseInt(q.dataset.lineChange, 10), line);
        return;
      }
      var quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        var body = new FormData();
        body.append('id', quick.dataset.quickAdd);
        body.append('quantity', 1);
        var f = document.createElement('form');
        var i = document.createElement('input'); i.name = 'id'; i.value = quick.dataset.quickAdd;
        var n = document.createElement('input'); n.name = 'quantity'; n.value = '1';
        f.append(i, n);
        addToCart(f, quick);
      }
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      var line = input.closest('[data-line-key]');
      changeLine(line.dataset.lineKey, parseInt(input.value, 10) || 0, line);
    });
  }

  /* ── predictive search ────────────────────────── */
  function initSearch() {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results) return;
    var timer, controller;
    var initial = results.innerHTML;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (controller) controller.abort();
      if (q.length < 2) { results.innerHTML = initial; return; }
      timer = setTimeout(function () {
        controller = new AbortController();
        var url = CFG.routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-search-results]');
            results.innerHTML = next ? next.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });

    input.addEventListener('keydown', function (e) {
      var rows = $$('.search__row', results);
      if (!rows.length) return;
      var i = rows.findIndex(function (r) { return r.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        rows.forEach(function (r) { r.setAttribute('aria-selected', 'false'); });
        i = e.key === 'ArrowDown' ? (i + 1) % rows.length : (i <= 0 ? rows.length - 1 : i - 1);
        rows[i].setAttribute('aria-selected', 'true');
      }
      if (e.key === 'Enter' && i > -1) { e.preventDefault(); rows[i].click(); }
    });
  }

  /* ── product gallery + variants ───────────────── */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var control = e.target.closest('[data-product-qty]');
      if (!control) return;
      var quantity = control.closest('.product-quantity')?.querySelector('[name="quantity"]');
      if (!quantity) return;
      var next = Math.max(1, (parseInt(quantity.value, 10) || 1) + parseInt(control.dataset.productQty, 10));
      quantity.value = next;
    });

    // gallery
    var slides = $('[data-gallery-slides]', root);
    var galleryItems = slides ? $$('.product__slide', slides) : [];
    function showGalleryItem(nextIndex) {
      if (!slides || !galleryItems.length) return;
      var current = Math.round(slides.scrollLeft / slides.clientWidth);
      var index = typeof nextIndex === 'number' ? nextIndex : current;
      index = (index + galleryItems.length) % galleryItems.length;
      slides.scrollTo({ left: slides.clientWidth * index, behavior: 'smooth' });
      $$('[data-gallery-thumb]', root).forEach(function (thumb) {
        thumb.setAttribute('aria-current', parseInt(thumb.dataset.galleryThumb, 10) === index ? 'true' : 'false');
      });
    }
    var galleryPrev = $('[data-gallery-prev]', root);
    var galleryNext = $('[data-gallery-next]', root);
    if (galleryPrev) galleryPrev.addEventListener('click', function () {
      showGalleryItem(Math.round(slides.scrollLeft / slides.clientWidth) - 1);
    });
    if (galleryNext) galleryNext.addEventListener('click', function () {
      showGalleryItem(Math.round(slides.scrollLeft / slides.clientWidth) + 1);
    });
    $$('[data-gallery-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.dataset.galleryThumb, 10);
        showGalleryItem(i);
      });
    });
    if (slides) {
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        $$('[data-gallery-thumb]', root).forEach(function (t) {
          t.setAttribute('aria-current', parseInt(t.dataset.galleryThumb, 10) === i ? 'true' : 'false');
        });
      }, { passive: true });
    }

    // variants
    var form = $('[data-product-form]', root);
    var data = $('[data-variants-json]', root);
    if (form && data) {
      var variants = JSON.parse(data.textContent);
      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-option-input]') && !e.target.matches('[data-option-input]')) return;
        var chosen = $$('[data-option-input]:checked, select[data-option-input]', root).map(function (i) { return i.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (o, idx) { return o === chosen[idx]; });
        });
        var idInput = $('[name=id]', form);
        var btn = $('[data-atc]', root);
        var priceEl = $('[data-product-price]', root);
        var compareEl = $('[data-compare-price]', root);
        var discountEl = $('[data-discount]', root);
        var inventory = $('[data-inventory-status]', root);
        var inventoryText = $('[data-inventory-text]', root);
        var labels = $$('[data-option-selected]', root);

        labels.forEach(function (l) { l.textContent = chosen[parseInt(l.dataset.optionSelected, 10)] || ''; });

        if (!match) {
          if (btn) { btn.disabled = true; btn.textContent = CFG.strings.soldOut; }
          return;
        }
        idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = money(match.price);
        if (compareEl) {
          compareEl.hidden = !(match.compare_at_price > match.price);
          compareEl.innerHTML = match.compare_at_price > match.price ? money(match.compare_at_price) : '';
        }
        if (discountEl) {
          var discount = match.compare_at_price > match.price
            ? Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price)
            : 0;
          discountEl.hidden = !discount;
          discountEl.textContent = discount ? 'Save ' + discount + '%' : '';
        }
        if (inventory && inventoryText) {
          var exact = inventory.dataset.showExact === 'true';
          var low = parseInt(inventory.dataset.lowStockThreshold, 10) || 5;
          var quantity = Number(match.inventory_quantity || 0);
          var text = 'In stock';
          if (!match.available) text = 'Out of stock';
          else if (match.inventory_management && quantity > 0) text = quantity <= low ? 'Only ' + quantity + ' left' : (exact ? quantity + ' in stock' : 'In stock');
          else if (match.inventory_policy === 'continue') text = 'Available to order';
          inventoryText.textContent = text;
          inventory.classList.toggle('is-out', !match.available);
          inventory.classList.toggle('is-low', match.available && match.inventory_management && quantity > 0 && quantity <= low);
        }
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available
            ? CFG.strings.addToCart + ' — ' + money(match.price)
            : CFG.strings.soldOut;
        }
        $$('[data-sticky-price]').forEach(function (el) { el.innerHTML = money(match.price); });
        $$('[data-sticky-atc-button]').forEach(function (el) { el.disabled = !match.available; });
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
        }
        // media switch by variant featured image
        if (match.featured_media_index != null && slides) {
          slides.scrollTo({ left: slides.clientWidth * match.featured_media_index, behavior: 'smooth' });
        }
      });
    }

    // sticky add-to-cart
    var sticky = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ── wishlist ─────────────────────────────────── */
  function initWishlist() {
    var list = store('bavl_wish', []);
    function paint() {
      $$('[data-wish]').forEach(function (b) {
        var on = list.indexOf(b.dataset.wish) > -1;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = b.querySelector('[data-wish-label]');
        if (label) label.textContent = on ? CFG.strings.saved : CFG.strings.save;
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]');
      if (!b) return;
      e.preventDefault();
      var id = b.dataset.wish;
      var i = list.indexOf(id);
      if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
      else { list.push(id); toast(CFG.strings.saved || 'Saved'); }
      save('bavl_wish', list);
      paint();
    });
    paint();
  }

  /* ── header hide on scroll down ───────────────── */
  function initHeader() {
    var header = $('[data-header]');
    if (!header || header.dataset.hideOnScroll !== 'true') return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('header--hidden', y > 300 && y > last && !$('.drawer.is-open'));
      last = y;
    }, { passive: true });
  }

  /* ── country / language selectors ─────────────── */
  function initLocalization() {
    $$('[data-localization-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        var input = form.querySelector('[name="country_code"], [name="locale_code"]');
        if (input) input.value = sel.value;
        form.submit();
      });
    });
  }

  /* ── info tooltips (the small "?" clarifiers) ──── */
  function initInfoTips() {
    if (initInfoTips._bound) return;
    initInfoTips._bound = true;
    function closeAllExcept(exceptTip) {
      $$('.info-tip.is-open').forEach(function (t) {
        if (t === exceptTip) return;
        t.classList.remove('is-open');
        var b = $('.info-tip__btn', t);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.info-tip__btn');
      var tip = btn ? btn.closest('.info-tip') : null;
      closeAllExcept(tip);
      if (!tip) return;
      e.preventDefault(); // some info-tips sit inside a <label>; don't let the click also refocus its field
      var open = tip.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllExcept(null);
    });
  }

  /* ── honest, fixed-end campaign countdown ─────── */
  function initCampaignCountdowns(root) {
    root = root || document;
    $$('[data-campaign-end]', root).forEach(function (timer) {
      if (timer.dataset.campaignReady === 'true') return;
      timer.dataset.campaignReady = 'true';
      var output = $('[data-campaign-countdown]', timer);
      var end = Date.parse(timer.dataset.campaignEnd);
      if (!output || Number.isNaN(end)) { timer.hidden = true; return; }
      function render() {
        var remaining = end - Date.now();
        if (remaining <= 0) {
          output.textContent = 'Campaign ended';
          timer.classList.add('is-ended');
          return false;
        }
        var totalSeconds = Math.floor(remaining / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        output.textContent = [hours, minutes, seconds].map(function (value) { return String(value).padStart(2, '0'); }).join(':');
        return true;
      }
      if (render()) timer._campaignInterval = window.setInterval(function () {
        if (!render()) window.clearInterval(timer._campaignInterval);
      }, 1000);
    });
  }

  /* ── order tracking (17TRACK widget — free, no API key, ─
     never touches a CJdropshipping credential from the browser) */
  function initTracking(root) {
    root = root || document;
    var form = $('[data-tracking-form]', root);
    if (!form || form.dataset.trackingBound === 'true') return;
    form.dataset.trackingBound = 'true';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('[data-tracking-input]', form);
      var num = (input.value || '').trim();
      var error = $('[data-tracking-error]', root);
      var result = $('[data-tracking-result]', root);
      if (!num) {
        if (error) { error.textContent = 'Enter a tracking number to see its status.'; error.hidden = false; }
        input.focus();
        return;
      }
      if (error) { error.textContent = ''; error.hidden = true; }
      if (typeof YQV5 === 'undefined') {
        if (error) {
          error.textContent = '';
          error.append('Live tracking didn\u2019t load just now (an ad or privacy blocker may be active). ');
          var fallback = document.createElement('a');
          fallback.href = 'https://www.cjpacket.com/?trackingNumber=' + encodeURIComponent(num);
          fallback.target = '_blank';
          fallback.rel = 'noopener';
          fallback.textContent = 'Track on CJPacket instead';
          error.append(fallback);
          error.hidden = false;
        }
        return;
      }
      if (result) result.hidden = false;
      YQV5.trackSingle({ YQ_ContainerId: 'YQContainer', YQ_Height: 620, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
      if (result) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── boot ─────────────────────────────────────── */
  function boot() {
    observeReveals(document);
    initTheme(); initDrawers(); initMobileNav(); initAnnouncement();
    initCart(); initSearch(); initProduct(); initProductCardSlides(); initProductHeroes(); initWishlist();
    initHeader(); initLocalization(); initCampaignCountdowns(); initTracking(); initInfoTips();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Re-apply the resolved theme after a bfcache restore (back/forward
  // navigation), which can skip re-running scripts but keeps stale DOM state.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncThemeLabel();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target); initProduct(); initProductCardSlides(e.target); initProductHeroes(e.target); initSearch(); initAnnouncement(); initMobileNav(); initCampaignCountdowns(e.target); initTheme(); initTracking(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('.drawer')) openDrawer(e.target.querySelector('.drawer').id);
  });

  window.BAVELIOM.openDrawer = openDrawer;
  window.BAVELIOM.refreshCart = refreshCart;
  window.BAVELIOM.toast = toast;
  window.BAVELIOM.initProductCardSlides = initProductCardSlides;
})();
